import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum SHEEPRANK {
  Daily = 1,
  Total = 0,
}

export enum SHEEPTASK {
  访问好友 = 1,
  充值 = 2,
  送礼上麦 = 3,
}

export enum SHEEPLEVEL {
  Lv1 = 1,
  Lv2 = 2,
  Lv3 = 3,
}

export enum COSTTYPE {
  羊毛 = 0,
  金币 = 1,
}

export enum TASKTYPE {
  未完成 = 0,
  完成未领取 = 1,
  完成已领取 = 2,
}
// 0: 生成的羊肉；1：被偷的羊肉; 2:被赠送的羊肉;3:攻击活得羊肉;4:赠送给别人羊肉;5:商城购买道具;6:羊羊大乱斗下注
export enum CHANGESTATUS {
  生成的 = 0,
  被偷的 = 1,
  被送的 = 2,
  攻击的 = 3,
  送人的 = 4,
  交易的 = 5,
  乱斗的 = 6,
}

export enum SHEEPSTATUS {
  可以赠送 = 0,
  可以攻击 = 1,
  未领羊未邀请 = 2,
  未领羊已邀请 = 3,
}

// 可攻击好友列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612084
export const getFriendList = createAsyncThunk(
  '/live/activity/lf_friend_list',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/activity/lf_friend_list',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 获取商城购买列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612074
export const getStoreInfo = createAsyncThunk(
  '/live/activity/lf_store_list',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/activity/lf_store_list',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 商城购买 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612086
export const buyInStore = createAsyncThunk(
  '/live/activity/lf_store_buy',
  async (
    arg: {good_id: number; currency_type: COSTTYPE; buy_cnt: number},
    store: any
  ) => {
    const resp = await http.post(
      '/live/activity/lf_store_buy',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 获取羊肉争夺战的榜单列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612078
export const getRankList = createAsyncThunk(
  '/live/activity/lf_rank_list',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/activity/lf_rank_list',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 获取用户的个人游戏信息或者对方的信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90611976
export const getUserInfo = createAsyncThunk(
  '/live/activity/lf_main_info',
  async (arg: {access_mid?: number; is_refresh?: boolean}, store: any) => {
    const resp = await http.post(
      '/live/activity/lf_main_info',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 给别人赠送羊肉 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90611976
export const sendLambToOther = createAsyncThunk(
  '/live/activity/lf_send_lamb',
  async (arg: {to_mid: number}, store: any) => {
    const resp = await http.post(
      '/live/activity/lf_send_lamb',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 获取用户的羊肉变动记录 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612061
export const getLambChangeList = createAsyncThunk(
  '/live/activity/lf_lamb_changes',
  async (arg: {offset?: number}, store: any) => {
    const resp = await http.post(
      '/live/activity/lf_lamb_changes',
      {
        offset: 0,
        ...arg,
        page_size: 30,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 获取用户的任务列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612049
export const getMissionList = createAsyncThunk(
  '/live/activity/lf_job_list',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/activity/lf_job_list',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 给自己的羊投喂饲料 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612062
export const feedSheep = createAsyncThunk(
  '/live/activity/lf_feed_sheep',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/activity/lf_feed_sheep',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 攻击别人的羊 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612100
export const attackSheep = createAsyncThunk(
  '/live/activity/lf_attack_sheep',
  async (arg: {to_mid: number}, store: any) => {
    const resp = await http.post(
      '/live/activity/lf_attack_sheep',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 领取任务奖励 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612038
export const accomplishMission = createAsyncThunk(
  '/live/activity/lf_job_reward',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/activity/lf_job_reward',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 邀请好友参与活动，发送IM http://wiki.xunlei.cn/pages/viewpage.action?pageId=132025739
export const inviteFriend = createAsyncThunk(
  '/live/activity/lf_invite_friend',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/activity/lf_invite_friend',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 获取pk信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=127598409
export const getPkInfo = createAsyncThunk(
  '/live/activity/lf_invite_friend',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/activity/lf_battle_info',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 羊羊大乱斗界面信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=127598420
export const getPkGame = createAsyncThunk(
  '/live/activity/lf_battle_game',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/activity/lf_battle_game',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 奖励 http://wiki.xunlei.cn/pages/viewpage.action?pageId=127576311
export const get_reward_by_tag = createAsyncThunk(
  '/live/commonactivity/get_reward_by_tag-sheep',
  async (arg: any, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        map: any
      }>
    >('/live/commonactivity/get_reward_by_tag', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

export enum PlayStatus {
  未开始 = 0,
  开始不在时间 = 1,
  进行中 = 2,
}

export interface StoreItemType {
  id?: number
  icon?: string // icon
  name?: string // name
  coin_price?: number // coin_price
  lamb_price?: number // lamb_price
  left_num?: number // 剩余购买次数
  limit_num?: number // 限制次数
  desc?: string // 商品介绍
  is_buy_limit?: boolean // 是否限购
}

export interface MemberType {
  name: string
  mid: number
  zy_id: string
  avatar: string
  gender: number
}
export interface JobItemType {
  id: number
  icon: string
  name: string
  status: TASKTYPE
  reward_fodder_num: number // 奖励饲料的数量
  reward_attack_num: number // 奖励攻击的数量
  job_need: number // 任务完成所需数值
  job_done: number // 任务现在已完成的数值
  type: SHEEPTASK // 任务类型
}

export interface ChangeType {
  ct: number
  change_num: number
  change_action: number
  member: MemberType
}

export interface PlaySheepInfo {
  id: number
  name: string
  odds: number
  is_me: boolean
  odds_icon: string
}

export interface FriendItemType {
  member: MemberType
  status: SHEEPSTATUS
}

interface InitialStateType {
  storeInfo: {
    lamb_num?: number // 羊毛剩余数量
    coins?: number // 金币数量
    list: Array<StoreItemType>
  }
  friendList: {
    list?: Array<FriendItemType>
  }
  rankList: any
  userInfo: {
    member?: any // 被访问的用户信息
    attack_num?: number // 剩余攻击次数
    fodder_num?: number // 剩余饲料数量
    lamb_num?: number // 剩余羊肉数量
    protect_expire?: number // 保护罩剩余有效时间
    lamb_sum_change?: number // 羊肉变化总值
    is_init_lamb?: boolean // 是否初始化
    is_first_init_lamb?: boolean // 是否第一次进入
    lamb_level?: SHEEPLEVEL // 羊羊等级
    lamb_exp_points?: number // 羊羊当前等级的经验值 100/500 的100
    lamb_exp_next_level_need?: number // 羊羊当前等级的经验值 100/500 的500
    is_max_level?: boolean
    can_feed_fodder_num?: number // 当日还可继续喂食的饲料数量
    lamb_get_per_attack?: number // 每次攻击获得的羊肉数量
    lamb_get_per_send?: number // 每次赠送的羊肉数量
    is_hungry?: boolean // 是否饥饿
    friend_lamb_num?: number // 好友的毛
  }
  changeList: any
  missionList?: {
    job_list?: Array<JobItemType>
  }
  map?: any
  sheep_status: {
    eat: boolean // 吃草状态
    open_friend: boolean // 打开好友列表
    open_task: boolean // 打开任务
    up_level: boolean // 是否升级
    cut_wool: boolean // 是否剪毛
    play_music: boolean
    happy: boolean
    step?: number // 1，2 2个阶段 1 喂草高亮 点击后喂草 2.喂草后退出在喂草高亮
  }
  pkInfo: {
    play_status: PlayStatus
    sheep_info?: Array<PlaySheepInfo>
    bet_amount_list?: Array<number>
    first_come?: boolean
  }
  pkResult: {
    collision_history_list?: Array<Array<number>>
    has_extra_coin_reward?: boolean // 是否有额外奖励
    extra_coin_num?: number // 额外奖励数量
    is_winner?: boolean // 本次输赢
    win_lamb_num?: number // 赢的羊毛
  }
}

const initialState: InitialStateType = {
  storeInfo: {list: []},
  friendList: {},
  rankList: {},
  userInfo: {
    // lamb_level: SHEEPLEVEL.Lv1,
  },
  changeList: [],
  missionList: {},
  sheep_status: {
    eat: false, // 吃屏蔽点击事件
    open_friend: false,
    open_task: false,
    up_level: false, // 升级屏蔽点击事件
    cut_wool: false, // 剪羊毛屏蔽点击事件
    play_music: false, // 背景音乐
    happy: false, // 开心
  },
  pkInfo: {
    play_status: PlayStatus.未开始,
  },
  pkResult: {},
}

export const RamadanSheepSlice = createSlice({
  name: 'RamadanSheep',
  initialState,
  reducers: {
    setStep: (state, action: PayloadAction<number>) => {
      Object.assign(state.sheep_status, {step: action.payload})
    },
    setHappy: (state, action: PayloadAction<boolean>) => {
      Object.assign(state.sheep_status, {happy: action.payload})
    },
    setPlayMusic: (state, action: PayloadAction<boolean>) => {
      Object.assign(state.sheep_status, {play_music: action.payload})
    },
    setSheepEat: (state, action: PayloadAction<boolean>) => {
      Object.assign(state.sheep_status, {eat: action.payload})
    },
    setSheepFriend: (state, action: PayloadAction<boolean>) => {
      Object.assign(state.sheep_status, {open_friend: action.payload})
    },
    setSheepTask: (state, action: PayloadAction<boolean>) => {
      Object.assign(state.sheep_status, {open_task: action.payload})
    },
    setLevel: (state, action: PayloadAction<number>) => {
      Object.assign(state.userInfo, {lamb_level: action.payload})
    },
    setUplevel: (state, action: PayloadAction<boolean>) => {
      Object.assign(state.sheep_status, {up_level: action.payload})
    },
    setCutWool: (state, action: PayloadAction<boolean>) => {
      Object.assign(state.sheep_status, {cut_wool: action.payload})
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserInfo.fulfilled, (state, action) => {
      Object.assign(state.userInfo, action.payload)
    })
    builder.addCase(getFriendList.fulfilled, (state, action) => {
      Object.assign(state.friendList, action.payload)
    })
    builder.addCase(getStoreInfo.fulfilled, (state, action) => {
      Object.assign(state.storeInfo, action.payload)
    })
    builder.addCase(getRankList.fulfilled, (state, action) => {
      Object.assign(state.rankList, action.payload)
    })
    builder.addCase(getLambChangeList.fulfilled, (state, action) => {
      Object.assign(state.changeList, action.payload)
    })
    builder.addCase(getMissionList.fulfilled, (state, action) => {
      Object.assign(state.missionList, action.payload)
    })
    builder.addCase(feedSheep.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(attackSheep.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(accomplishMission.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(get_reward_by_tag.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(getPkInfo.fulfilled, (state, action) => {
      Object.assign(state.pkInfo, action.payload)
    })
    builder.addCase(getPkGame.fulfilled, (state, action) => {
      Object.assign(state.pkResult, action.payload)
    })
  },
})

export default RamadanSheepSlice.reducer
export const RamadanSheepActions = RamadanSheepSlice.actions
